module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ytcDOD/tc-custom/9781638295143.jpg?1705766126803",
      "alt": "This image is the cover for the book The Unusual Cure and Untold Story of Dr. John Langone, Dr. of Psychiatry"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Unusual Cure and Untold Story of Dr. John Langone, Dr. of Psychiatry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This work of fiction, entitled "), _c('em', [_vm._v("The Unusual Cure and Untold Story of Dr. John Langone, Dr. of Psychiatry")]), _vm._v(", tells the story of a depressed psychiatrist who contemplates suicide. He falls in love with the heroine of the story, and his life changes from that moment on. It is a true tragedy with an extensive cast of characters involved.  ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vernon Michael dechastaigne Craig\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black"
    }
  }, [_vm._v("Vernon Michael Dechastaigne Craig was born in New York City. His father was a Marine Corps Captain wounded in Guadalcanal, Solomon Islands during World War II. Vernon Craig attended night school at Harvard Extension and also attended the College of William and Mary.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "0mm",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif",
      "text-align": "justify",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif",
      "color": "black"
    }
  }, [_vm._v("He is a lead actor in the American movie "), _c('em', [_vm._v("The Man Who Knew Bush")]), _vm._v(", also, Unicow Productions of "), _c('em', [_vm._v("Satan and the Saint")]), _vm._v(", which was distributed by Indie Elix Seattle Washington.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0